import { render } from "./CreatorDeliverableCreativeAsset.vue?vue&type=template&id=4a1a7c20"
import script from "./CreatorDeliverableCreativeAsset.vue?vue&type=script&lang=js"
export * from "./CreatorDeliverableCreativeAsset.vue?vue&type=script&lang=js"

import exportComponent from "/Applications/MAMP/htdocs/laravel/sundae-scoops/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__